<template>
	<div>
		<loader-component v-if="loading" :loader-message="'Loading...'"></loader-component>
		<div v-else class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
			<div v-if="submitted" class="row justify-content-center">
				<div class="col-md-5">
					<request-summary-component :request="form" :type="'investment'"></request-summary-component>

					<div class="col-12 mg-t-20 text-center">
						<button type="button" class="btn btn-default wd-lg-200 mx-auto shadow-sm" @click="toggleSubmit()">Go Back</button>
					</div>
				</div>
			</div>
			<div class="d-flex flex-wrap" v-else>
				<div :class="liquidityFlag.active ? 'col-lg-3' : 'col-lg-5'">
					<iclf-announcement-component />
				</div>
				<div v-if="liquidityFlag.active" class="col-lg-9">
					<div class="mg-b-5">
						<p class="tx-uppercase tx-11 tx-spacing-1 tx-color-03 tx-medium">Amount Invested</p>
						<p class="tx-26 tx-normal tx-rubik tx-spacing--2"><small class="text-muted tx-light">GHS: </small> {{ amountContributed | toNumber | placeholder }}</p>
					</div>

					<div class="row">
						<deposit-form-component :header-title="'Add Funds'" :deposit="form" :form="form" @performDeposit="contribute" :deposit-class="'col-lg-5'" />
						<bank-details-component :reference="form.external_client_id" :type-label="'Investments'" :bank-type="'iclf'" :bank-class="'col-lg-6'" />
					</div>
				</div>
				<div v-else class="col-lg-5">
					<h4>ICLF closed</h4>
					<p>We are in the process of allocating shares to successful applicants. Successful applicants will begin to receive notifications from 2nd May 2022.</p>
					<p>Please contact <a href="mailto:clientservice@ic.africa">client service</a> if you have any questions.</p>
				</div>
			</div>
			<h4 v-if="!submitted" class="mg-t-20">ICLF Investments</h4>
			<transactions-table-component v-if="!submitted" :show-price="false" :show-units="false" />
		</div>
	</div>
</template>


<script>
export default {
	mounted() {
		this.fetchIclfContribution();
	},
	data() {
		const { portfolio: portfolio_id } = this.$route.params;
		const { account_code, external_client_id } = this.$store.getters.company
		const { phone, email } = this.$store.getters.user.client;


		return {
			email,
			loading: true,
			amountContributed: null,
			submitted: false,
			liquidityFlag: {
				active: true,
			},
			form: new Form({
				portfolio_id,
				account_code,
				external_custody_account_id: null,
				external_client_id,
				phone,
				amount: 0,
				charges: 0,
				total_units: 0,
				units: null,
				amount: null,
				currency: 'GHS',
				type: 'investment',
				funding_channel: null,
				payment_service: null,
				payment_type: null,
				processing_no: null,
				reference: null,
				price: null,
				security: 'ICAMGH-F003',
			}),
		};
	},
	methods: {
		fetchIclfContribution() {
			this.loading = true;
			const { portfolio } = this.$route.params;

			axios
				.get(`/api/portfolio/${portfolio}/holdings`, {
					params: {
						security: 'ICAMGH-F003',
					},
				})
				.then(
					({
						data: {
							data: { holdings },
						},
					}) => {
						const { value: price } = holdings.security_details.price;

						this.external_custody_account_id = holdings.external_custody_account_id;
						this.amountContributed = holdings.units;
						this.form.price = price;
					}
				)
				.finally(() => {
					this.submitted = false;
					this.loading = false;
				});
		},
		contribute() {
			if (this.form.amount) {
				this.form.post('/api/requests').then(() => {
					if (this.form.payment_service === 'paystack') {
						this.payWithPaystack();
					} else {
						this.submitted = true;
					}
				});
			}
		},
		payWithPaystack() {
			const paymentHandler = PaystackPop.setup({
				key: process.env.MIX_PAYSTACK_PUBLIC_KEY_ICAM,
				email: this.email,
				label: this.form.phone,
				amount: Math.round(this.form.amount * 100),
				ref: this.form.processing_no,
				currency: 'GHS',
				channels: [this.form.payment_type],
				onClose: () => {
					this.verifyTransaction(this.form.reference);
					this.submitted = true;
				},
				callback: ({ reference }) => {
					this.submitted = true;
					this.verifyTransaction(reference);
				},
			});

			return paymentHandler.openIframe();
		},
		verifyTransaction(reference) {
			axios.post('/api/transactions/verify', {
				reference,
			});
		},
		setData(err, flag) {
			if (err) {
				this.error = err.toString();
			} else {
				this.$nextTick(() => (this.liquidityFlag = flag));
			}
		},
		toggleSubmit() {
			this.fetchIclfContribution();
			this.form.reset();
		},
	},
};
</script>